
      export default {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"viewBox":"0 0 33 33","fill":"none","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('circle',{attrs:{"cx":"16.656","cy":"16.344","r":"16","fill":"#D2D5D9","stroke":"#D2D5D9","stroke-linecap":"round"}}),_c('path',{staticClass:"black-fill",attrs:{"fill-rule":"evenodd","clip-rule":"evenodd","d":"M17.149 13.168c-.022 8.701.006 8.01-.356 8.747-.552 1.125-1.626 1.787-2.895 1.786-1.255-.002-2.337-.674-2.876-1.786-.325-.67-.421-1.53-.245-2.195.436-1.641 2.127-2.712 3.74-2.37.175.038.343.069.372.069.042 0 .053-.386.053-1.787v-1.788l-.202-.034c-.366-.061-1.534-.033-1.993.048-3.832.681-6.326 4.323-5.516 8.058.561 2.592 2.682 4.67 5.303 5.194 3.473.696 6.948-1.389 7.92-4.751.262-.903.258-.804.245-5.483-.006-2.35.002-4.273.019-4.273.016 0 .1.055.185.123 1.22.96 3.389 1.71 4.951 1.71h.383l-.011-1.758-.011-1.758-.412-.027c-2.687-.176-4.873-2.355-5.09-5.077l-.029-.373h-3.516l-.02 7.725z","fill":"#fff"}})])
          )
        }
      }
    